document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ag-complementary][hidden]').forEach((el) => {
    const wrapper = el.closest('.shopify-section');

    const productId = el.getAttribute('data-product-id');
    const limit = el.getAttribute('data-limit') || '8';
    const heading = el.getAttribute('data-heading') || 'Pairs Well With';
    const base = el.getAttribute('data-recs-url') || '/recommendations/products';

    if (!productId) {
      // Not on a product page (or product object missing)
      wrapper?.remove();
      return;
    }

    const url =
      `${base}?product_id=${encodeURIComponent(productId)}` +
      `&intent=complementary` +
      `&limit=${encodeURIComponent(limit)}` +
      `&section_id=ag-complementary-render`;

    fetch(url, { credentials: 'same-origin' })
      .then(async (r) => ({ status: r.status, text: await r.text() }))
      .then(({ status, text }) => {
        if (status !== 200) {
          wrapper?.remove();
          return;
        }

        const doc = new DOMParser().parseFromString(text, 'text/html');

        // Must match what ag-complementary-render.liquid outputs
        const rendered = doc.querySelector('[data-ag-complementary]');
        const hasCards = rendered && rendered.querySelector('.ag-complementary__card');

        if (!rendered || !hasCards) {
          wrapper?.remove();
          return;
        }

        // Force title from the *placeholder section setting* (single source of truth)
        const titleEl = rendered.querySelector('.ag-complementary__title');
        if (titleEl) titleEl.textContent = heading;

        // Swap placeholder with server-rendered markup
        el.outerHTML = rendered.outerHTML;
      })
      .catch(() => {
        wrapper?.remove();
      });
  });
});